import { createFileRoute, useParams } from "@tanstack/react-router"
import { useGroupAttendanceOverviewQuery } from "@/api/queries/groups/useGroupAttendanceOverviewQuery"
import { checkPermissions } from "@/utils/checkPermissions"
import { GroupAttendanceOverview } from "toptaal-shared"

export const Route = createFileRoute(
  "/beheer/groepen/$groupId/presentie-overzicht/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "groups"),
})

function RouteComponent() {
  const { groupId } = useParams({
    from: "/beheer/groepen/$groupId/presentie-overzicht/",
  })

  const { data } = useGroupAttendanceOverviewQuery({
    groupId: Number(groupId),
  })

  return (
    <GroupAttendanceOverview
      lessons={data?.lessons ?? []}
      students={data?.students ?? []}
    />
  )
}
